<template>
	<div class="container_head " @click="showss = false">
        <div class="sousuo" v-show="showss">
            <div class="sousuocontent">
                <input type="search" placeholder="详细地址搜索" id="si" v-model="keywords" @input='mhss' v-on:compositionstart='con = false' v-on:compositionend='con = true'>
                <div class="soushushequlist">
                    <van-loading type="spinner" color="#1989fa" v-show="isload" />
                    <div v-for="(item,index) in fwcolumns " :key="index" @click="dian(item)">
                        <span>{{item.text}}</span>
                    </div>
                </div>
            </div>
        </div>
		<van-form @submit="onSubmit">
			<div class="card">
				<div class="title">新增房屋信息</div>
				<van-field name="houses1" label="选择房屋" v-if="houselist.length>0" label-width="4.5em"
					:rules="[{ required: true, message: '必填' }]">
					<template #input>
						<van-checkbox-group v-model="checkboxGroup" direction="vertical">
							<van-checkbox :name="item.houseId" shape="square" v-for="(item,i) in houselist"
								class="mb10">{{item.community}}{{item.houseName}}</van-checkbox>
						</van-checkbox-group>
					</template>
				</van-field>
				<!-- <van-field v-model="qhxz" is-link readonly label="区划选择" placeholder="请选择所在地区" @click="show0 = true" label-width="4.2em"  v-if="houselist.length==0" />
				<van-popup v-model="show0" round position="bottom" v-if="houselist.length==0">
					<van-cascader v-model="cascaderValue0" title="请选择所在地区" :options="optionarea" @close="show0 = false"
						@finish="onFinish0" />
				</van-popup> -->
                <van-field v-model="fwdz" label="小区名称" placeholder="请输入小区名称" name="houses2"
					@click.stop="showxx" :rules="[{ required: true, message: '必填' }]" label-width="4.2em"
					/>
				<van-field v-model="xqdz" is-link readonly label="房屋地址" placeholder="请选择房屋所在地址" name="houses2"
					@click="onFinish0" :rules="[{ required: true, message: '必填' }]" label-width="4.2em"
					v-if="houselist.length==0&&fwdz!=''" />
				<van-popup v-model="show" round position="bottom" v-if="houselist.length==0">
					<van-cascader v-model="cascaderValue" :options="options" @close="show = false"
						@change="onChange" @finish="onFinish" :placeholder="'请选择'+currarr">
						<template #title>
							<span class="custom-title">区划房屋选择</span>
							<button class="xz" type="button" v-show="showxz" @click.stop="addhousetc">新增</button>
						</template>
						</van-cascader>
				</van-popup>
				<div class="sfxz" v-show="xqdz"> 
					<span>身份选择：</span>
					<van-radio-group v-model="sfchecked" direction="horizontal">
						<van-radio name="1">业主</van-radio>
						<van-radio name="2">业主家属</van-radio>
						<van-radio name="3">租客</van-radio>
					</van-radio-group>
				</div>
				<!-- <van-field v-show="sfchecked == 2 || sfchecked == 3" v-model="yzname" label="业主姓名" placeholder="请输入业主的姓名"  /> -->
			</div>
			<div class="tip">*请如实填写信息，以便正常使用平台服务</div>
			<div style="margin: 16px 30px;">

				<van-button round block type="info" native-type="submit" class="btnorange" style="margin-bottom: 10px;">
					提交</van-button>
			</div>
		</van-form>
		<van-overlay :show="showxzly" @click="closelouyu">
            <div class="bohui" @click.stop>
                <div class="bh-title">
                    <span>新增楼宇</span>
                    <img src="../../assets/close.png" alt="" class="close" @click="closelouyu">
                </div>
                <van-cell-group>
					<van-field required v-show="currtbidx<1" v-model="xzlist.buildingNo"  label="楼栋号" maxlength='20' placeholder="请输入楼栋号" input-align="right" ></van-field>
					<van-field required v-show="currtbidx<2" v-model="xzlist.unitName"  label="单元号" maxlength='20' placeholder="请输入单元号" input-align="right" ></van-field>
					<van-field required v-show="currtbidx<3" v-model="xzlist.floorNum"  label="楼层" maxlength='20' placeholder="请输入楼层" input-align="right" ></van-field>
					<van-field required v-show="currtbidx<4" v-model="xzlist.ucAddress"  label="房屋号" maxlength='20' placeholder="请输入房屋号" input-align="right" ></van-field>
				</van-cell-group>
                <button class="tj" @click='addhouse'>保存</button>
            </div>
        </van-overlay>
		
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Form,
		Cascader,
		Checkbox,
		CheckboxGroup
	} from 'vant';
	Vue.use(Form);
	Vue.use(Cascader);
	Vue.use(Checkbox);
	Vue.use(CheckboxGroup);
	import { Dialog } from 'vant';
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
                keywords:'',
                showss:false,
                fwdz:'',
                fwid:'',
                con:true,
                isload:false,
                fwcolumns:[],
				checkboxGroup: [],
				houselist: [],
                yzname:'',//业主姓名
				show0: false,
				show: false,
				showxzly:false,//展示新增楼宇
				showxz:false,//是否展示新增楼宇的按钮
				currarr:'小区',
				currtbidx:'',//选择房屋时当前的联级
				currselected:[],//当前选择好的
				qhxz: '',
				cascaderValue0: '',
				optionarea: [],
				xqdz: '',
				cascaderValue: '',
				options: [],
				queryobj: {},
				chooseIndex:[0,0,0,0,0],
				xzlist:{},
				idmen:{},
				sfchecked:'',//身份选择
			};
		},
        watch:{
            sfchecked(newval,oldval){
                if(newval == 1){
                    this.yzname = ''
                }
            }
        },
		computed: {
			...mapState(["identity"]),
		},
		mounted() {
			var obj = this.$route.query;
			if (!obj) {
				this.$router.push('/fzrz')
				return
			}
			this.queryobj = obj;
			//第一步 区划选择
			// this.$axios.get('/api/v2/wechat/select/region').then(res => {
			// 	var newarray=[];
			// 	res.map(obj=>{
			// 		newarray.push({
			// 			value:obj.id,
			// 			pid:obj.pId,
			// 			text:obj.text
			// 		})
			// 	})
			// 	this.optionarea = this.formatTreeData(newarray);
			// })
		},
		methods: {
			...mapMutations(["changeIdentity"]),
			formatTreeData(arr) {
				// 删除所有的children，以防止多次调用
				arr.forEach(item => {
					delete item.children;
				});
				// 构建map
				let map = {};
				arr.forEach(c => {
					map[c.value] = c;
				});
				let treeData = [];
				arr.forEach(c => {
					const mapItem = c.pid ? map[c.pid] : '';
					if (c.pid != "" && mapItem) {
						// mapItem 存在，说明当前数据不是顶层数据
						(mapItem.children || (mapItem.children = [])).push(c);
					} else {
						// mapItem 不存在，说明当前数据是顶层数据
						treeData.push(c);
					}
				});
				return treeData;
			},
            //模糊搜索的接口
            async mhss(){
                var that = this
                that.isload = true
                that.fwcolumns=[]
                if(that.con && that.ischiness(that.keywords)){
                    that.fwcolumns=[]
                    that.fwcolumns = await new Promise((resolve,reject)=>{
                        that.$axios.get('/api/v2/wechat/select/community',{
                            params:{
                                key:that.keywords
                            }
                        }).then(res=>{
                            var columns = res.map(item=>{
                                return {
                                    text:item.text,
                                    id:item.id
                                }
                            })
                            that.isload = false
                            resolve(columns)
                        })
                    })
                }
            },
            dian(event){
                var that = this
                that.fwdz = event.text
                that.fwid = event.id
                that.showss = false
            },
            showxx(){
                var that = this
                that.showss = true
                setTimeout(() => {
                    document.querySelector('#si').focus()
                }, 100);   
            },
            ischiness(str){
                if(/[a-zA-Z]/.test(str)){
                    return false
                }else{
                    return true
                }
            },
			closelouyu(){
				this.showxzly = false
				this.show = true
			},
			addhousetc(){
				this.showxzly = true
				this.show = false
			},
			addhouse(){
				var addarr = Object.values(this.xzlist)
				if(addarr.includes('')){
					this.$toast.fail('有必填项未填写！')
				}else{
					this.xqdz = ''
					for(var i = 0;i<this.currtbidx+1;i++){
						this.xqdz += this.currselected[i].text
					}
					var arr = Object.values(this.xzlist)
                    debugger
					this.xqdz+=arr.join('-')
					this.showxzly = false
				}
			},
			onChange({
				value,
				selectedOptions,
				tabIndex
			}) {
				console.log(value, selectedOptions, tabIndex)
				this.currtbidx = tabIndex
				this.currselected=selectedOptions
				this.currarr = ''
				if(tabIndex==0){
					// 第三步获取单元
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.$axios.get('/api/v2/wechat/select/bunit',{
						params: {
							buildingId:value,
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text+'单元',
								value:obj.id,
								children:[]
							})
						})
						this.options[this.chooseIndex[0]].children=objarray;
						// this.showxz = true
						this.showxz = false//2023-05-22 按需求禁掉
						this.currarr = '单元'
					})
				}else if(tabIndex==1){
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options[this.chooseIndex[0]].children.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.idmen.buildingId = selectedOptions[1].value
					//单元选择
					this.$axios.get('/api/v2/wechat/select/floor',{
						params: {
							bunitId:value,
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text+'楼',
								value:obj.id,
								children:[]
							})
						})
						this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children=objarray;
						this.currarr = '楼层'
					})
					
				}else if(tabIndex==2){
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.idmen.buildingId = selectedOptions[1].value
					this.idmen.bunitId = selectedOptions[2].value
					// 第四步获取楼层
					this.$axios.get('/api/v2/wechat/select/house',{
						params: {
							floorId:value,
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text+'室',
								value:obj.id,
							})
						})
						this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children[this.chooseIndex[2]].children=objarray;
						this.currarr = '房屋号'
					})
				}
			},
			
			onFinish0() {
				this.show = true;
				// 第二步获取楼栋
				this.$axios.get('/api/v2/wechat/select/building',{
					params: {
                        communityId:this.fwid,
                        key:''
                    }
				}).then(res=>{
					var objarray=[];
					res.map(obj=>{
						objarray.push({
							text:obj.text+'栋',
							value:obj.id,
							children:[]
						})
					})
					this.options=objarray.filter(item=>{
                        return item.text.indexOf('车库') == -1
                    });
                    this.currarr = '楼栋号'
				})
			},
            f(a){
                if(isNaN(Number(a,10))){
                    return false
                }
                else{
                    return true
                }
            },
			onFinish({
				selectedOptions
			}) {
				this.show = false;
                this.xqdz=''
				selectedOptions.forEach((option,index) => {
                    var na = ''
                    if(index == 1 && this.f(option.text)){
                        na = option.text+'栋'
                    }else if(index == 2 && this.f(option.text)){
                        na = option.text+'单元'
                    }else if(index == 3 && this.f(option.text)){
                        na = option.text+'楼'
                    }else if(index == 4 && this.f(option.text)){
                        na = option.text+'室'
                    }else{
                        na = option.text
                    }
                    this.xqdz += na
                })
				this.idmen.villageId = this.fwid
				this.idmen.buildingId = selectedOptions[0].value
				this.idmen.bunitId = selectedOptions[1].value
				this.idmen.floorId = selectedOptions[2].value
				this.idmen.houseId = selectedOptions[3].value
			},

			onSubmit(values) {
				var finialobj={};
				if(this.sfchecked == ''){
					this.$toast.fail('身份未选择')
                    return
				}
                // else if((this.sfchecked == '2' || this.sfchecked == '3') && this.yzname == ''){
                //     this.$toast.fail('业主姓名未填写')
                //     return
                // }
                else{
					// 库里没有这个人的房屋，需选择区划后获得的房屋，只能选一个
					if(this.cascaderValue==''){
						Dialog({ message: '您还没有选择！' });
						return
					}
					if(this.currtbidx != 4){
						finialobj = {
							...this.queryobj,
							userType:this.sfchecked,
						}
						var xuankeys = Object.keys(this.idmen)
						xuankeys.forEach(item=>{
							finialobj[item] = this.idmen[item]
						})
						var keys = Object.keys(this.xzlist)
						keys.forEach(item=>{
							finialobj[item] = this.xzlist[item]
						})
						console.log(finialobj)
					}else{
						finialobj = {
							...this.queryobj,
							villageId:this.idmen.villageId,
							userType:this.sfchecked,
							buildingId:this.idmen.buildingId,
							bunitId:this.idmen.bunitId,
							floorId:this.idmen.floorId,
							houseId:this.idmen.houseId
						}
					}
                    // if(this.sfchecked == '2' || this.sfchecked == '3'){
                    //     finialobj.ownerName = this.yzname
                    // }
					this.$axios({
						url: '/api/v2/wechat/user/register',
						method: 'post',
						data: finialobj,
					}).then(res => {
                        console.log(res)
						// 0未认证  2：房主认证  20：待审核
						// this.changeIdentity(20);
						// Dialog({ message: '请耐心等待后台审核！' });
						if(res){
							this.$toast.success('成功！')
							setTimeout(() => {
								this.$router.push({path:'/home'})
							}, 1000);
						}
					}); 
				}
			},
			back() {
				this.$router.go(-1)
			}
		}
	};
</script>

<style lang="less" scoped>
	.mb10 {
		margin-bottom: 10px;
	}
	/deep/ .van-overlay{
		display: flex;
		align-items: center;
		justify-content: center;
	}
    .sousuo{
        position: absolute;
        background-color: #eee;
        width: 100%;
        z-index: 999;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 0 0 20px 20px;
        padding: 0 0 10px 0;
        box-sizing: border-box;
        .sousuocontent {
            width: 94%;
        }
        .soushushequlist{
            display: flex;
            flex-direction: column;
            overflow: hidden;
            overflow-y: scroll;
            max-height: 400px;
            div{
                margin-top: 15px;
                span{
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
        input::-webkit-input-placeholder{
            color: #eeeeee;
            text-align: center;
        }
        input {
            border: 1px solid #ececec;
            border-radius: 20px;
            height: 40px;
            width: 100%;
            margin-top: 10px;
        }
    }
	.bohui{
		// height: 275px;
		width: 90%;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 10px;
		.bh-title{
			height: 40px;
			background: #e8f1f9;
			width: 100%;
			padding: 0 10px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 13px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			.close{
				height: 20px;
			}
		}
		.bh-text{
			width: 90%;
			height: 55%;
			margin-top: 10px;
		}
		.tj{
			width: 80%;
			height: 40px;
			margin-top: 10px;
			color: #fff;
			background: #0089ff;
			border-radius: 10px;
			border: none;
			outline: none;
			margin-bottom: 10px;
		}
	}
	.xz{
		height: 20px;
		width: 60px;
		background: linear-gradient(90deg, #fcae37, #fe784b);
		border: none;
		border-radius: 5px;
		color: #fff;
		margin-left: 20px;
		font-size: 13px;
	}
	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.card {
		margin: 0px 15px;
		background-color: #fff;
		border-radius: 10px;
		padding: 10px 0;
	}

	.title {
		color: #ffad0e;
		font-size: 18px;
		text-align: center;
		margin: 5px 0 10px;
		font-weight: bold;
	}
	.sfxz{
		display: flex;
		align-items: center;
		justify-content: space-around;
		height: 44px;
		font-size: 14px;
	}
	.tip {
		color: #ffa5a5;
		font-size: 12px;
		padding: 0px 5px 0 25px;
	}

	/deep/.van-field--error .van-field__control::placeholder {
		color: #ccc;
	}
</style>
